import { $apiV1, $apiV2 } from "../config/api";


export const getTokenForVideoList = async (markers, title, allMarkers = []) => {
  try {
    const response = await $apiV2.post("/video/list/create", { 'markers': markers, 'title': title, 'allMarkers': allMarkers });
    return response.data.token;
  } catch (error) {
    alert("Error creating video list");
  }
}

export async function getVideoList(token) {
  try {
    const response = await $apiV2.get(`/video/list/get/${token}`);
    return response.data;
  } catch (error) {
    alert("Token expired");
  }
} 


// Flatten marker IDs out of a /stats/team or /stats/player response.
// Shape: { stats: [{ match_id, parameters: [{ parameter_id, markers: [..ids], ... }] }] }
const collectMarkersFromStatsResponse = (data) => {
  const markerSet = new Set();
  const rows = Array.isArray(data?.stats) ? data.stats : [];

  rows.forEach((row) => {
    (row?.parameters || []).forEach((parameter) => {
      (Array.isArray(parameter?.markers) ? parameter.markers : []).forEach(
        (marker) => {
          if (marker !== null && marker !== undefined && marker !== "") {
            markerSet.add(marker);
          }
        }
      );
    });
  });

  return Array.from(markerSet);
};

// Lazily fetch the marker IDs for a single stat (team or player) across a set
// of matches. The team overview payload no longer ships marker arrays, so the
// markers needed to build a video clip list are fetched on demand when a stat
// is clicked. Reuses the existing /stats/team and /stats/player endpoints.
export async function fetchStatMarkers({
  kind = "team",
  id,
  matchIds = [],
  paramId,
  opponent = false,
} = {}) {
  const matches = (matchIds || []).filter(
    (matchId) => matchId !== null && matchId !== undefined && matchId !== ""
  );

  if (!id || !paramId || matches.length === 0) {
    return [];
  }

  const params = {
    matches: matches.join(","),
    params: paramId,
  };
  // `oponnent` (sic) only applies to team stats.
  if (kind === "team" && opponent) {
    params.oponnent = true;
  }

  const path = kind === "player" ? `/stats/player/${id}` : `/stats/team/${id}`;

  try {
    const response = await $apiV1.get(path, { params });
    return collectMarkersFromStatsResponse(response?.data);
  } catch (error) {
    console.error("Error fetching stat markers:", error);
    return [];
  }
}

// Fetch a stat's markers then open the video list. Drop-in replacement for the
// old `openVideoList(item.markers.join(","), title)` call sites that used to
// rely on markers being inlined in the overview payload.
export async function openStatVideo(context, title, newTab = false) {
  const markers = await fetchStatMarkers(context);
  if (markers.length === 0) {
    console.warn("No markers available for stat video", context);
    return;
  }
  await openVideoList(markers.join(","), title, newTab);
}

export async function openVideoList(
  markers,
  title,
  new_tab = false,
  allMarkers = [],
  merged = false,
  selectedOnly = false,
  startWithFullSequence = false
) {
  console.log('allMarkers', allMarkers);
  let allMarkersString = null;
  if (allMarkers.length > 0) {
    allMarkersString = allMarkers.map((item) => item).join(",");
  }

  console.log('allMarkersString', allMarkersString);

  const token = await getTokenForVideoList(markers, title, allMarkersString);
  const mergedSuffix = merged ? '&merged=1' : '';
  // Immediate-events sequences: join only the selected markers into one merged
  // video, so non-selected markers in the full set don't split it apart.
  const selectedSuffix = selectedOnly ? '&selected=1' : '';
  // Event pages with a sequence-context filter should enter the viewer with
  // the first event already expanded to its entire possession sequence.
  const fullSequenceSuffix = startWithFullSequence ? '&full_sequence=1' : '';
  if (new_tab) {
    window.open(`/tournaments/match/videos?token=${token}${mergedSuffix}${selectedSuffix}${fullSequenceSuffix}`, "_blank")
  } else {
    window.open(`/tournaments/match/videos?token=${token}${mergedSuffix}${selectedSuffix}${fullSequenceSuffix}`)
  }
}
